import { getNormalisedLead } from 'app/dealer/leads/utils';

import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    dealerLoggedIn: true,
    leadPending: false,
    lead: getNormalisedLead({}),
    leadError: null,
    leadUpdatePending: false,
    leadUpdateError: null,
  };
};

export function lead(state = defaultState(), action) {
  const { type, payload, error } = action;

  if (type === ActionTypes.GET_LEAD_REQUEST) {
    state = {
      ...state,
      lead: getNormalisedLead({}),
      leadPending: true,
      leadError: null,
    };
  } else if (type === ActionTypes.GET_LEAD_SUCCESS) {
    state = {
      ...state,
      lead: payload,
      leadPending: false,
      leadError: null,
    };
  } else if (type === ActionTypes.GET_LEAD_ERROR) {
    state = {
      ...state,
      lead: getNormalisedLead({}),
      leadError: error,
      leadPending: false,
    };
  }

  return state;
}
